import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/program-hub")({
  component: lazyRouteComponent(() => import("./-pages/admin.program-hub")),
  head: () => ({
    meta: [{ title: "برنامج الولاء والسفراء · Lecmo Admin" }],
  }),
});
